import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_linear_progress = _resolveComponent("q-linear-progress")!

  return (_openBlock(), _createElementBlock("div", null, [
    _renderSlot(_ctx.$slots, "default", _normalizeProps(_guardReactiveProps({ loading: _ctx.loading })), () => [
      _withDirectives(_createVNode(_component_q_linear_progress, { indeterminate: "" }, null, 512), [
        [_vShow, _ctx.loading]
      ])
    ])
  ]))
}